import React, {useState} from 'react';
import {ViewCodeMap} from '../../../helpers/table';
import {ButtonMore, ButtonTypes, InfoButton} from '../../../ui-kit/Button';
import {
  ActionColumn,
  CodeInput,
  CodeColumn,
  ActionBtn,
  MenuActionIt,
  CodeColumnLine,
  CodeNames,
  CodeListWrapper,
  DropDownText,
  ViewMoreButton,
  MaxCodesLabel,
} from './styles';
import {emailState, emailStateVal, ModalLvl} from './Table';
import {codeItemT, CodeSendStatuses} from '../../../types/codes';
import {validateEmail} from '../../../helpers/codes';
import {codeState, codeStateVal, useGuestChangeCodesT} from '../../../hooks/groups';
import {ItemType} from 'antd/es/menu/hooks/useItems';
import {Dropdown, Menu} from 'antd';
import {InputNumber} from '../../../ui-kit/Input';
import {CloseCircleOutlined} from '@ant-design/icons';
import {MAX_CODES_PER_GUEST} from '../../../helpers/helpers';
import styled from 'styled-components';

export type ItemProps = {
  addRow?: boolean;
  edit?: boolean;
  code?: string;
  email?: string;
  emailstate?: emailState;
  guestName?: string;
  id?: string;
  isEditing?: boolean;
  focusId?: string;
  setEmail?: (v: emailStateVal) => void;
  setName?: (v: emailStateVal) => void;
  setFocusId?: (id?: string) => void;
  editingId?: string;
  unused?: codeItemT[];
  used?: codeItemT[];
  codesState: useGuestChangeCodesT;
  codeStatus?: CodeSendStatuses;
};

type InputItemProps = {
  field: 'name' | 'email';
  editingId?: string;
  eCodeState?: codeState;
  eCodeSetState?: (val: codeStateVal) => void;
};

export const QuantityItem: React.FC<ItemProps> = ({addRow, id, editingId, unused, used, codesState}) => {
  if (!id) return null;
  const isCurrentEditing = editingId === id;
  const totalUnused = Number(unused?.length || 0);
  const totalUsed = Number(used?.length || 0);
  const availableCount = totalUnused - totalUsed;
  const maxCodes = 10 < availableCount ? 10 : availableCount;

  const onChange = codesState?.changeCodes(id);
  const value = codesState.codes?.[id];
  const inc = () => {
    // const next = Number(value || 0) + 1;
    // if (next > maxCodes) return;
    onChange?.(Number(value || 0) + 1);
  };
  const dec = () => {
    const next = Number(value || 0) - 1;
    if (next < totalUsed) return;
    onChange?.(next);
  };

  if (addRow)
    return (
      <CodeColumn>
        <InputNumber
          min={0}
          max={maxCodes}
          addonBefore={<button onClick={dec}>-</button>}
          addonAfter={
            <button onClick={inc} disabled={value === totalUnused}>
              +
            </button>
          }
          controls={false}
          //eslint-disable-next-line
          //@ts-ignore
          onChange={onChange}
          value={value}
          disabled={!totalUnused}
        />
      </CodeColumn>
    );

  const incDisabled = value === totalUsed + totalUnused;
  if (isCurrentEditing)
    return (
      <CodeColumn>
        <InputNumber
          min={0}
          max={maxCodes}
          addonBefore={<button onClick={dec}>-</button>}
          addonAfter={
            <button onClick={inc} disabled={incDisabled}>
              +
            </button>
          }
          controls={false}
          //eslint-disable-next-line
          //@ts-ignore
          onChange={onChange}
          value={value}
        />
      </CodeColumn>
    );

  return (
    <CodeColumnLine>
      <InputNumber
        min={0}
        addonBefore={<button disabled={true}>-</button>}
        addonAfter={<button disabled={true}>+</button>}
        controls={false}
        value={used?.length}
        disabled={true}
      />
    </CodeColumnLine>
  );
};

export const CodesItem: React.FC<ItemProps> = ({used}) => {
  const codes = used?.map((el) => el?.code);
  let codeNames = '';
  const codesMore = (used?.length || 0) > 2;
  if (codesMore) codeNames = codes?.slice(0, 2)?.join(', ') + '...';
  else codeNames = codes?.join(', ') || '';

  return (
    <CodeColumnLine>
      <CodeNames>{codeNames}</CodeNames>
      {codesMore && <MoreCodesDropDown codes={codes} />}
    </CodeColumnLine>
  );
};

const MoreCodesDropDown: React.FC<{codes: (string | undefined)[] | undefined}> = ({codes}) => {
  const [open, setOpen] = useState(false);
  const handleOpenChange = (flag: boolean) => {
    setOpen(flag);
  };
  const codesList = (
    <CodeListWrapper>
      {codes?.map((code: string | undefined) => (
        <DropDownText key={code}>{code}</DropDownText>
      ))}
    </CodeListWrapper>
  );

  return (
    <ViewMoreButton>
      <Dropdown
        overlay={codesList}
        trigger={['click']}
        placement="bottomRight"
        onVisibleChange={handleOpenChange}
        visible={open}>
        <DropDownText>View more</DropDownText>
      </Dropdown>
    </ViewMoreButton>
  );
};

export const InputItem: React.FC<ItemProps & InputItemProps> = ({
  email,
  id,
  setEmail,
  emailstate,
  setFocusId,
  field,
  guestName,
  editingId,
  eCodeState,
  eCodeSetState,
}) => {
  const isCurrentEditing = id && editingId === id;
  const onFocus = () => setFocusId?.(id);
  const onChangeName = (e: any) => setEmail?.({key: String(id), [field]: e?.target?.value});
  const onChangeEmail = (e: any) => setEmail?.({key: String(id), [field]: e?.target?.value.trim()});
  const onChange = field === 'email' ? onChangeEmail : onChangeName;
  const onCodeStateChangeName = (e: any) => eCodeSetState?.({key: field, value: e?.target?.value});
  const onCodeStateChangeEmail = (e: any) => eCodeSetState?.({key: field, value: e?.target?.value.trim()});
  const onCodeStateChange = field === 'email' ? onCodeStateChangeEmail : onCodeStateChangeName;

  const value = field === 'email' ? email : guestName;

  if (!id) return null;
  if (isCurrentEditing)
    return (
      <CodeColumn>
        <CodeInput
          placeholder={`Type ${field}...`}
          value={eCodeState?.[field] || ''}
          onChange={onCodeStateChange}
          onFocus={onFocus}
        />
      </CodeColumn>
    );

  return (
    <CodeColumn>
      {value || email ? (
        <div>{value}</div>
      ) : (
        <CodeInput
          placeholder={`Type ${field}...`}
          value={emailstate?.[id]?.[field] || ''}
          onChange={onChange}
          onFocus={onFocus}
          // type={'email'}
        />
      )}
    </CodeColumn>
  );
};

export type ActionsItemProps = {
  edit?: boolean;
  id?: string;
  codeStatus?: CodeSendStatuses;
  setDelPopup?: (lvl: ModalLvl) => void;
  setFocusId?: (id?: string) => void;
  setEditing?: (b: boolean) => void;
  onSendCode?: (id?: string) => void;
  focusedId?: string;
  loading?: boolean;
  emailstate?: emailState;
  email?: string;
  setEditingId?: (id?: string) => void;
  editingId?: string;
  eCodeState?: codeState;
  onUpdateCode?: () => void;
  updateTarget: (id?: string, eCodeState?: codeState, isAdd?: boolean) => Promise<boolean | undefined>;
  addRow?: boolean;
  codeCount?: number;
  unused?: codeItemT[];
  used?: codeItemT[];
  onEmailPreview?: (id?: string) => Promise<void>;
};

export const ActionsItem: React.FC<ActionsItemProps> = ({
  codeStatus,
  onSendCode,
  id,
  setFocusId,
  loading,
  emailstate,
  email,
  eCodeState,
  setEditingId,
  editingId,
  updateTarget,
  addRow,
  codeCount,
  setDelPopup,
  unused,
  used,
  onEmailPreview,
}) => {
  const isCurrentEditing = id && editingId === id;
  const setEdit = () => setEditingId?.(id);
  const onCancelEdit = () => setEditingId?.('');
  const onSend = () => {
    setFocusId?.(id);
    onSendCode?.(id);
  };
  const onPreview = () => onEmailPreview?.(id);
  const canSave = (id && validateEmail(emailstate?.[id]?.email) && emailstate?.[id]?.name) || email;
  const canAdd = id && validateEmail(emailstate?.[id]?.email) && emailstate?.[id]?.name && codeCount;
  const rowUsed = used?.length || 0;
  const rowUnused = unused?.length || 0;
  const saveDisabled = !codeCount ? true : codeCount > rowUnused + rowUsed || codeCount > MAX_CODES_PER_GUEST;
  const onUpdateTarget = () => {
    if (id && !saveDisabled) updateTarget(id, addRow ? undefined : eCodeState, addRow);
  };

  const onDelete = () => {
    setFocusId?.(id);
    setDelPopup?.(ModalLvl.confirm);
  };
  if (addRow)
    return (
      <ActionColumn>
        <ActionBtn
          variant={ButtonTypes.secondary}
          onClick={onUpdateTarget}
          disabled={loading || !canAdd || saveDisabled}>
          Save
        </ActionBtn>
        {(codeCount || 0) > MAX_CODES_PER_GUEST && <MaxCodes />}
      </ActionColumn>
    );
  if (isCurrentEditing)
    return (
      <ActionColumn>
        <ActionBtn variant={ButtonTypes.secondary} onClick={onCancelEdit} disabled={loading}>
          Cancel
        </ActionBtn>
        <ActionBtn
          variant={ButtonTypes.secondary}
          onClick={onUpdateTarget}
          disabled={loading || !eCodeState?.valid || saveDisabled}>
          Update
        </ActionBtn>
        {(codeCount || 0) > MAX_CODES_PER_GUEST && <MaxCodes />}
      </ActionColumn>
    );

  if (codeStatus === CodeSendStatuses.notsent && id && !email)
    return (
      <ActionColumn>
        <ActionBtn
          variant={ButtonTypes.secondary}
          onClick={onUpdateTarget}
          disabled={loading || !canSave || saveDisabled}>
          Save
        </ActionBtn>
        {(codeCount || 0) > MAX_CODES_PER_GUEST && <MaxCodes />}
      </ActionColumn>
    );
  if (codeStatus === CodeSendStatuses.notsent)
    return (
      <ActionColumn>
        <ActionBtn variant={ButtonTypes.secondary} onClick={setEdit} disabled={loading}>
          Edit
        </ActionBtn>
        <ActionBtn variant={ButtonTypes.secondary} onClick={onSend} disabled={loading}>
          Send
        </ActionBtn>
        <MenuMoreNotSentPromoGroup onDelete={onDelete} onPreview={onPreview} />
      </ActionColumn>
    );

  const sendText = codeStatus === CodeSendStatuses.sent || codeStatus === CodeSendStatuses.queued ? 'Resend' : 'Send';
  return (
    <ActionColumn>
      {codeStatus === CodeSendStatuses.queued && <InfoButton variant={ViewCodeMap?.sent}>Queued</InfoButton>}
      {codeStatus === CodeSendStatuses.sent && <InfoButton variant={ViewCodeMap?.sent}>Code Sent</InfoButton>}
      <>
        {id && email && (
          <MenuMorePromocode
            isEditing={false}
            onEdit={setEdit}
            onSend={onSend}
            onPreview={onPreview}
            sendText={sendText}
          />
        )}
      </>
    </ActionColumn>
  );
};

export type MenuMorePromocodeProps = {
  isEditing: boolean;
  id?: string;
  onEdit?: () => void;
  onSend?: () => void;
  onPreview?: () => void;
  sendText: string;
};

export const MenuMorePromocode: React.FC<MenuMorePromocodeProps> = ({onEdit, onSend, onPreview, sendText}) => {
  const ddActions: ItemType[] = [
    {key: 1, label: <MenuActionIt onClick={onEdit}>Edit</MenuActionIt>},
    {key: 2, label: <MenuActionIt onClick={onPreview}>Preview Email</MenuActionIt>},
    {
      key: 3,
      label: <MenuActionIt onClick={onSend}>{sendText}</MenuActionIt>,
    },
  ];

  return (
    <Dropdown overlay={<Menu items={ddActions} />} trigger={['click']}>
      <ButtonMore />
    </Dropdown>
  );
};

const MaxCodes = () => (
  //eslint-disable-next-line
  //@ts-ignore
  <MaxCodesLabel $valid={false} icon={<CloseCircleOutlined />}>
    No more than {MAX_CODES_PER_GUEST} codes per email
  </MaxCodesLabel>
);

export type MenuMoreNotSentPromoGroupProps = {
  id?: string;
  onPreview?: () => void;
  onDelete?: () => void;
};

export const MenuMoreNotSentPromoGroup: React.FC<MenuMoreNotSentPromoGroupProps> = ({onPreview, onDelete}) => {
  const ddActions: ItemType[] = [
    {key: 1, label: <MenuActionIt onClick={onPreview}>Email Preview</MenuActionIt>},
    {
      key: 2,
      label: <MenuActionIt onClick={onDelete}>Delete</MenuActionIt>,
    },
  ];

  return (
    <Dropdown overlay={<Menu items={ddActions} />} trigger={['click']}>
      <MoreWrapper>
        <ButtonMore />
      </MoreWrapper>
    </Dropdown>
  );
};

const MoreWrapper = styled.div`
  margin-left: 12px;
  background-color: rgba(0, 0, 0, 0.02);
`;
